import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { TabsStateService } from "@shared/services/tabs-state/tabs-state.service";
import { ICenter } from "@shared/models/center";
import { CentersService } from "@shared/services/api/centers/centers.service";
import { AzaraWrapperComponent } from "@shared/components/azara-wrapper/azara-wrapper.component";
import { FormsModule } from "@angular/forms";

@Component({
    templateUrl: "./centers.component.html",
    styleUrl: "./centers.component.scss",
    selector: "app-centers",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AzaraWrapperComponent, FormsModule],
})
export class CentersComponent {
    private readonly dataService = inject(CentersService);
    private readonly centersService = inject(CentersService);
    private readonly tabsService = inject(TabsStateService);
    private readonly router = inject(Router);

    public scopedCenter = signal<ICenter | null>(null);
    public centers = toSignal(this.dataService.centers$);

    public onSubmit($event: Event): void {
        $event.preventDefault();
        const newScopedCenter = this.scopedCenter();
        const previousScopedCenter = this.centersService.scopedCenter();

        if (!newScopedCenter) return;

        if (previousScopedCenter?.id !== newScopedCenter.id) {
            this.tabsService.resetTabs();
        }

        this.centersService.setScopedCenter(newScopedCenter);

        const activeTab = this.tabsService.getActiveTab();
        const queryParams = activeTab ? { ...activeTab.queryParams, tabId: activeTab.tabId } : { tabId: 0 };
        const url = activeTab ? activeTab.tabComponentUrl : "/bedside-shift-report";

        this.router.navigate([url], { queryParams });
    }
}
